import { gql } from '@apollo/client';

export const DELETE_TUTOR = gql`
  mutation DeleteTutor($input: DeleteTutorInput!) {
    deleteTutor(input: $input) {
      tutorId
    }
  }
`;
